export const CommercialList = [
  { id: 20, type: "Shop", count: 2 },
  { id: 1, type: "Showroom", count: 22 },
  { id: 2, type: "Office", count: 45 },
  { id: 3, type: "Office In IT Park", count: 77 },
  { id: 4, type: "Office In Business Park", count: 78 },
  { id: 5, type: "Business Center", count: 2 },
  { id: 6, type: "Commercial Building", count: 2 },
  { id: 7, type: "Commercial land", count: 89 },
  { id: 8, type: "Basement", count: 2 },
  { id: 9, type: "Industrial Land / Building", count: 22 },
  { id: 10, type: "Industrial Shed / Gala", count: 2 },
  { id: 11, type: "Ware House / Godown", count: 2 },
  { id: 12, type: "Hotel", count: 2 },
  { id: 13, type: "Resort", count: 2 },
  { id: 14, type: "Restaurant", count: 90 },
  { id: 15, type: "Corporate House", count: 2 },
  { id: 16, type: "Factory", count: 221 },
  { id: 17, type: "Hospital", count: 2 },
  { id: 18, type: "School", count: 66 },
  { id: 19, type: " Other option Type", count: 2 },
];

export const ResidentialList = [
  { id: 20, type: "Flat/ Apartment", count: 2 },
  { id: 1, type: "Independent Bunglow / Villa", count: 22 },
  { id: 2, type: "Row House / House", count: 45 },
  { id: 3, type: "Penthouse", count: 77 },
  { id: 4, type: "Duplex", count: 78 },
  { id: 5, type: "Twin Flat", count: 2 },
  { id: 6, type: "Service  Apartment", count: 2 },
  { id: 7, type: "Studio Apartment", count: 89 },
  { id: 8, type: "PG", count: 2 },
  { id: 9, type: "Farm Housed", count: 22 },
  { id: 10, type: "Guest Housed", count: 2 },
  { id: 11, type: "Commercial  Flat", count: 2 },
  { id: 12, type: "Commercial Banglow", count: 2 },
  { id: 13, type: "Commercial Building", count: 2 },
  { id: 14, type: "Commercial Land", count: 90 },
  { id: 15, type: "NA Land / Plot", count: 2 },
  { id: 16, type: "Agricultural land / Farm Land", count: 221 },
  { id: 17, type: "Other Type", count: 678 },
];
export const PossessionStatus = [
  { Id: 1, Name: "Ready To Move in" },
  { Id: 2, Name: "Date Option" },
];
export const PossessionStatusRequrement = [
  { id: 1, type: 10 },
  { id: 2, type: 15 },
  { id: 3, type: 30 },
];
export const BHKType = [
  { id: 1, type: "1 BHK" },
  { id: 2, type: "1.5 BHK" },
  { id: 3, type: "2 BHK" },
  { id: 4, type: "2.5 BHK" },
  { id: 5, type: "3 BHK" },
  { id: 6, type: "3+ BHK" },
];
export const FurnishedStatus = [
  { id: 0, type: "Not Specified" },
  { id: 1, type: "Un Furnished" },
  { id: 2, type: "Semi Furnished" },
  { id: 3, type: "Furnished" },
  { id: 4, type: "Fully Furnished" },
];
export const saleableArea = [
  { id: 1, type: "Sq Ft" },
  { id: 2, type: "Sq Mt" },
  { id: 3, type: "Sq Yards" },
  { id: 4, type: "Guntha" },
  { id: 5, type: "Acres" },
  { id: 6, type: "Hectares" },
];

export const Parking = [
  { id: 0, type: "Parking" },
  { id: 1, type: "Covered reserved" },
  { id: 2, type: "No Car Park" },
  { id: 3, type: "Not Specified" },
  { id: 4, type: "Common Car Park" },
];
export const AvailableFor = [
  { id: 0, type: "Working Girl", value: true },
  { id: 1, type: "Working Boy", value: true },
  { id: 2, type: "Student Girl", value: true },
  { id: 3, type: "Student Boy", value: true },
  { id: 4, type: "Family", value: true },
  { id: 5, type: "Foreigner", value: true },
  { id: 6, type: "For All", value: true },
];
export const Floor = [
  { id: 0, type: "Not Specified" },
  { id: 1, type: "Lower" },
  { id: 2, type: "Mid" },
  { id: 3, type: "Higher" },
];
export const ClientType = [
  { id: 0, type: "Working Girl" },
  { id: 1, type: "Working Boy" },
  { id: 2, type: "Student Girl" },
  { id: 3, type: "Student Boy" },
  { id: 4, type: "Family" },
  { id: 5, type: "Foreigner" },
  { id: 6, type: "For All" },
];
export const AmenitiesList = [
  { Id: 1, type: "Swimming Pool" },
  { Id: 2, type: "Lift" },
  { Id: 3, type: "Park" },
  { Id: 4, type: "Jogging Track" },
  { Id: 5, type: "Gym" },
  { Id: 6, type: "Club House" },
  { Id: 7, type: "Community Hall" },
  { Id: 8, type: "Tennis Court" },
  { Id: 9, type: "Basketball Court" },
  { Id: 10, type: "Children Play Area" },
  { Id: 11, type: "Indoor Games" },
  { Id: 12, type: "Outdoor Areas" },
  { Id: 13, type: "Outdoor Gym" },
];

export const PlottingAmenitiesList = [
  { Id: 1, type: "Gated Community" },
  { Id: 2, type: "24x7 Security" },
  { Id: 3, type: "Main Entrance Arch" },
  { Id: 4, type: "Wide Internal Roads" },
  { Id: 5, type: "Street Lighting" },
  { Id: 6, type: "Underground Electricity" },
  { Id: 7, type: "Underground Drainage" },
  { Id: 8, type: "Water Supply" },
  { Id: 9, type: "Rainwater Harvesting" },
  { Id: 10, type: "Landscaped Parks" },
  { Id: 11, type: "Children's Play Area" },
  { Id: 12, type: "Walking Track" },
  { Id: 13, type: "Avenue Plantation" },
  { Id: 14, type: "Clubhouse" },
  { Id: 15, type: "Multipurpose Hall" },
  { Id: 16, type: "Yoga Lawn" },
  { Id: 17, type: "Meditation Zone" },
  { Id: 18, type: "Outdoor Gym" },
  { Id: 19, type: "Power Backup for Common Areas" },
  { Id: 20, type: "CCTV Surveillance" },
];

export const CallingClient = [
  { id: 1, type: "New Project" },
  { id: 2, type: "Rental" },
  { id: 3, type: "Resale" },
  { id: 4, type: "Plot" },

];

export const LeadHistoryType = {
  Lead: "Lead",
};
export const timeList = [
  { id: 1, name: "12:00 AM" },
  { id: 2, name: "12:30 AM" },
  { id: 3, name: "1:00 AM" },
  { id: 4, name: "1:30 AM" },
  { id: 5, name: "2:00 AM" },
  { id: 6, name: "2:30 AM" },
  { id: 7, name: "3:00 AM" },
  { id: 8, name: "3:30 AM" },
  { id: 9, name: "4:00 AM" },
  { id: 10, name: "4:30 AM" },
  { id: 11, name: "5:00 AM" },
  { id: 12, name: "5:30 AM" },
  { id: 13, name: "6:00 AM" },
  { id: 14, name: "6:30 AM" },
  { id: 15, name: "7:00 AM" },
  { id: 16, name: "7:30 AM" },
  { id: 17, name: "8:00 AM" },
  { id: 18, name: "8:30 AM" },
  { id: 19, name: "9.00 AM" },
  { id: 20, name: "9.30 AM" },
  { id: 21, name: "10.00 AM" },
  { id: 22, name: "10.30 AM" },
  { id: 23, name: "11.00 AM" },
  { id: 24, name: "11.30 AM" },
  { id: 25, name: "12.00 PM" },
  { id: 26, name: "12.30 PM" },
  { id: 27, name: "1.00 PM" },
  { id: 28, name: "1.30 PM" },
  { id: 29, name: "2.00 PM" },
  { id: 30, name: "2.30 PM" },
  { id: 31, name: "3.00 PM" },
  { id: 32, name: "3.30 PM" },
  { id: 33, name: "4.00 PM" },
  { id: 34, name: "4.30 PM" },
  { id: 35, name: "5.00 PM" },
  { id: 36, name: "5.30 PM" },
  { id: 37, name: "6.00 PM" },
  { id: 38, name: "6.30 PM" },
  { id: 39, name: "7.00 PM" },
  { id: 40, name: "7.30 PM" },
  { id: 41, name: "8.00 PM" },
  { id: 42, name: "8.30 PM" },
  { id: 43, name: "9.00 PM" },
  { id: 44, name: "9.30 PM" },
  { id: 45, name: "10.00 PM" },
  { id: 46, name: "10.30 PM" },
  { id: 47, name: "11.00 PM" },
  { id: 48, name: "11.30 PM" },
];
export const contactListCompletedWithResponse = [
  { name: "New", id: 1 },
  { name: "Ringing", id: 2 },
  { name: "Wrong Number", id: 4 },
  { name: "Switch Off", id: 5 },
  { name: "Not Connected", id: 6 },
  { name: "Busy", id: 7 },
  { name: "Out Of Service", id: 8 },
  { name: "Disconnected", id: 9 },
  { name: "Invalid", id: 10 },
  { name: "Incoming Not Available", id: 11 },
  { name: "Not Interested", id: 12 },
  { name: "Call Back", id: 13 },
  { name: "Interested But Call After Some Time", id: 14 },
  { name: "Interested in New Project", id: 15 },
  { name: "Interested In Plot", id: 16 },
  { name: "Interested In Resale", id: 17 },
  { name: "Interested In Rental", id: 18 },
  { name: "Rental Property Available", id: 19 },
  { name: "Resale Property Available", id: 20 },
  { name: "Plot For Sale", id: 21 },
  { name: "Plot For Rent", id: 22 },
  { name: "Other Remark", id: 23 },
];


export const LeadActivityTypes =[
    { id: 1, name: "New" },
    { id: 2, name: "Site Visit" },
    { id: 3, name: "Follow-Up" },
    { id: 4, name: "Meeting" },
    { id: 5, name: "Any Task" },
    { id: 6, name: "Requirement Hold" },
    { id: 7, name: "Requirement Postponed" },
    { id: 8, name: "Requirement cancel" },
    { id: 9, name: "Deal Closed Own" },
    { id: 10, name: "Deal Closed By Other Broker" },
    { id: 11, name: "Deal Closed By Direct Owner" },
    { id: 12, name: "Rent Agreement Task" },
    { id: 13, name: "Police Verification Task" },
    { id: 14, name: "Sell Deed" },
    { id: 15, name: "Agreement to sale" },
    { id: 16, name: "Owner Visit" },
  ];
